// const CONFIGURATION = require(`@/assets/env/${process.env.VUE_APP_CLIENT}/config.json`);
const CONFIGURATION = await import(`@/assets/env/${process.env.VUE_APP_CLIENT}/config.json`);
export default CONFIGURATION.default as Config;

console.log("Loaded configuration:", CONFIGURATION);

export interface Config {
    cookie_consent_id: string | null,
    recaptcha_site_key: string | null,
    feature: {
        messages: boolean,
        events: boolean,
        consents: boolean,
        surveys: boolean,
        extra_definitions: boolean,
        therapy_trend: boolean,
        prn_therapies: boolean,
        show_prn_therapies: boolean,
        journey_schemas: boolean,
        otp_login: boolean,
        report_adverse_event: boolean,
    },
    available_locales: string[],
    available_genders: number[],
    footer_links: string[] | null

}

export type { FooterLink, Environment } from './env';